import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Table, Spin, Space } from "antd";
import { getAllGroups, getAllUsersData } from "store/adminPanel/actions";
import { Popover, Tooltip } from "@mui/material";
import { Checkbox } from "components";
import { ReactComponent as ActionsIcon } from '../../../../../assets/icons/more_dots.svg';
import ActionList from './components/ActionList';
import SearchComponent from './components/SearchComponent';
// import { CreateModal } from "./components/CreateModal";
// import { DeleteModal } from "./components/DeleteModal";
// import { ViewModal } from "./components/ViewModal";
// import { EditModal } from "./components/CreateModal";
import TableCell from "./components/TableCell";
import CreateModal from "./components/CreateModal";
import DeleteModal from "./components/DeleteModal";
import EditModal from "./components/EditModal";
import ViewModal from "./components/ViewModal";

const   GroupsConfig = () => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const dispatch = useDispatch();
    const groups = useSelector((state => state.adminPanel.allGroups));
    const [displayedGroups, setDisplayedGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedGroup,setSelectedGroup] = useState("");
    const [open, setOpen] = useState(Boolean(anchorEl));
    const [createOpen, setCreateOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    const displayedItems = displayedGroups && displayedGroups.slice(startIndex, endIndex);
    const [checked, setChecked] = useState(false);
    const [editedPriv, setEditedPriv] = useState(false);

    useEffect(() => {
        dispatch(getAllGroups());
    }, []);
    // console.log("groups:",groups);
    useEffect(()=>{
        if(groups){
            setDisplayedGroups(groups);
        }
    },[groups])

    useEffect(() => {
        if(groups){
            setLoading(false);
        }
    }, [groups]);

    useEffect(()=>{
        if(editOpen || viewOpen){
            setOpen(false);
            setAnchorEl(null);
        }
    },[editOpen,viewOpen])

    const handlePageChange = page => {
        setCurrentPage(page);
        setChecked(false);
        setSelectedGroups([]);
      };
    const onMoreClick = (id) => (event) => {
        setSelectedGroup(id);
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };
    const checkAll = () => {
        if(checked){
            setChecked(false);
            setSelectedGroups([]);
        }
        else{
            const uniqueValuesSet = new Set([
            ...selectedGroups,
            ...displayedItems.map(item=>item.id)
            ]);
            const uniqueValuesArray = Array.from(uniqueValuesSet);
            setSelectedGroups(uniqueValuesArray);
            setChecked(true);
        }
    }
    const handleCheck = (id) => {
        if(selectedGroups.includes(id)){
            const tempSelectedGroups = selectedGroups.filter(item => item != id);
            setSelectedGroups(tempSelectedGroups);
        } else {
            setSelectedGroups([...selectedGroups, id]);
        }
    }
      
    const columns = [
        {
            title: <Checkbox checked={checked} onChange={()=>checkAll()}></Checkbox>,
            dataIndex: 'id',
            render: (value) => {
                return <Checkbox checked={selectedGroups.includes(value)} onChange={()=>handleCheck(value)}></Checkbox>;
            }
        },
        {
            title: "Group ID",
            dataIndex: 'id',
            key: 'id',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "Type",
            dataIndex: 'type',
            key: 'type',
            render: text => {
                return <TableCell text={text} />;
            },
        },
        {
            title: "",
            fixed: 'right',
            key: "action",
            align: "right",
            render: (text, record) => {
                console.log('Rendering action column:', record);
                return (
                    <Space align="end">
                        <Tooltip title="Actions">
                            <ActionsIcon aria-describedby={record.id} onClick={(e) => onMoreClick(record.id)(e)} style={{ cursor: "pointer"}} />
                        </Tooltip>
                    </Space>
                );
            },
        },
    ];

    return (
        loading ?
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "50px"
            }}
        >
            <Spin size="large" />
        </div>
        :
        <div id="users-config-page">
            <SearchComponent 
                displayedGroups={displayedGroups} 
                setDisplayedGroups={setDisplayedGroups} 
                allGroups={groups} 
                setChecked={setChecked} 
                setSelectedGroups={setSelectedGroups} 
                setCurrentPage={setCurrentPage} 
                className='shrunk' 
            />
            <div style={{display:"flex", justifyContent:"right", alignItems:"right", marginTop:"5rem"}}>
                <Button className="config-create" type="default" onClick={()=>setCreateOpen(true)}>Create</Button>
                <Button style={{marginLeft:"1.438rem"}} className="config-delete" type="primary" onClick={()=>setDeleteOpen(true)}>Delete</Button>
            </div>
            <div style={{marginTop:"3rem"}}>
                <Table
                    scroll={{ x: true }}
                    className="results-table"
                    dataSource={displayedGroups}
                    columns={columns}
                    rowKey="id"
                    pagination={{ showSizeChanger: false, showTitle: false, onChange: handlePageChange }}
                />
            </div>
            <div>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center', 
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <ActionList open={()=>setOpen()} anchorEl={()=>setAnchorEl()} id={selectedGroup} setEditOpen={setEditOpen} setViewOpen={setViewOpen}/>
                </Popover>
            </div>
            <CreateModal
                isVisible={createOpen}
                setVisible={setCreateOpen}
                groups={groups}
            />
            <DeleteModal
                isVisible={deleteOpen}
                setVisible={setDeleteOpen}
                selectedGroups={selectedGroups}
                setSelectedGroups={setSelectedGroups}
            />
            <EditModal
                isVisible={editOpen}
                setVisible={setEditOpen}
                groupId={selectedGroup}
                setEditedPriv={setEditedPriv}
            />
            <ViewModal
                isVisible={viewOpen}
                setVisible={setViewOpen}
                groupId={selectedGroup}
                editedPriv={editedPriv}
                setEditedPriv={setEditedPriv}
            />
        </div>
    );
};

export default GroupsConfig;